import * as angular from "angular";
import {IController} from "angular";

export class AgentListCtrl implements IController {

  ids: any;
  infiniteScroll: any;
  showLink: any;
}

angular
  .module('bringoz.admin.agents')
  .component('agentList', {
    bindings: {
      ids: '<?',
      infiniteScroll: '<?',
      showLink: '@?'
    },
    template: require('./agent-list.html').default,
    controller: AgentListCtrl
  });
